var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tag',{class:`status ${
      _vm.isPaid ? 'success' : 'pending'
    } border-radius text-capitalize font-bold`,attrs:{"type":"default"}},[_vm._v(_vm._s(_vm.status))])
}
var staticRenderFns = []

export { render, staticRenderFns }